import axios from "../axios";

//查询遥控器列表
export const queryRemotorList = (data) => {
    return axios({
        url: "common/query_remotor_list",
        method: "post",
        data
    })
}

//修改遥控器
export const modifyRemotor = (data) => {
    return axios({
        url: "common/modify_remotor",
        method: "post",
        data
    })
}